import buildCurrentEmployerSection from './CurrentEmployer';
import SecondEmployerSection from './SecondEmployer';
import PreviousEmployerSection from './PreviousEmployer';
import { NO_EMPLOYER_INFO_STATUSES, EMPLOYER_INFO_STATUSES } from './constants';

const buildEmploymentStatusSection = ({ isFinanciallyResponsible }) => {
  return {
    name: 'employmentStatus',
    title: 'EMPLOYMENT STATUS',
    titleVariant: 'subsection',
    divider: true,
    container: 'default',
    fields: [
      {
        variant: 'singleSelect',
        name: 'employmentStatus',
        label: 'What is your current employment status?',
        options: [
          { text: 'Employed', value: 'employed' },
          { text: 'Not Employed', value: 'notEmployed' },
          { text: 'Retired', value: 'retired' },
          { text: 'Student', value: 'student' },
          { text: 'Other', value: 'other' },
        ],
        changeActions: [
          {
            type: 'updateField',
            target: 'secondJobDoesNotApply',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: true,
          },
          {
            type: 'updateField',
            target: 'secondJobDoesNotApply',
            when: {
              in: EMPLOYER_INFO_STATUSES,
            },
            value: false,
          },
          // Clear Current Employer fields for statuses with no employer
          {
            type: 'updateField',
            target: 'currentJobPosition',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobAnnualSalary',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobStartDate',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobEmployerName',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobEmployerPhone',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobSupervisorName',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobStreetAddress',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobCity',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobState',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'currentJobZipCode',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          // Clear Second Employer fields for statuses with no employer
          {
            type: 'updateField',
            target: 'secondJobPosition',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobAnnualSalary',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobStartDate',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobEmployerName',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobEmployerPhone',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobSupervisorName',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobStreetAddress',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobCity',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobState',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
          {
            type: 'updateField',
            target: 'secondJobZipCode',
            when: {
              in: NO_EMPLOYER_INFO_STATUSES,
            },
            value: '',
          },
        ],
        rules: {
          required: true,
        },
        GridProps: {
          xs: 12,
          md: 3,
        },
      },
      buildCurrentEmployerSection({ isFinanciallyResponsible }),
      ...(isFinanciallyResponsible
        ? [
            SecondEmployerSection,
            PreviousEmployerSection,
            {
              variant: 'radioGroup',
              name: 'anticipateChangeEmployer',
              label:
                'Do you anticipate having a change with your current employer situation in the next 12 months?',
              rules: {
                required: true,
              },
              options: [
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
              ],
              sx: {
                flexDirection: 'row',
              },
            },
            {
              variant: 'banner',
              status: 'info',
              message:
                'Note: You must inform us if your employment information changes prior to move-in.',
              GridProps: { xs: 12 },
            },
          ]
        : []),
    ],
  };
};

export default buildEmploymentStatusSection;
